/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2024, Zumper
 * @description app download banner redux slice
 */

import { createSlice } from '@reduxjs/toolkit'

export const appBannerSlice = createSlice({
  name: 'appBanner',
  initialState: {
    appBannerShowing: false,
    bannerAlreadyShown: false,
  },
  reducers: {
    hideAppBanner: (state) => {
      state.appBannerShowing = false
    },
    showAppBanner: (state) => {
      state.appBannerShowing = true
    },
    setBannerAlreadyShown: (state) => {
      state.bannerAlreadyShown = true
    },
  },
})

export const { reducer } = appBannerSlice
export const { hideAppBanner, showAppBanner, setBannerAlreadyShown } = appBannerSlice.actions
